/**
 * Конфигурация фильтров для таблицы
 */
import {
  ColumnFiltersDict,
  multiSelectColumnFilter,
} from "src/components/ReactiveTable/components/AntDropdownFilter";
import { RtCtrlFiltration } from "src/components/ReactiveTable/ctrl";

import { roleOptions, statusOptions } from "./constants";
import { UserFilters } from "./types";

/**
 * Создает конфигурацию фильтров для колонок таблицы
 */
export const createColumnFilters = <
  TStore extends RtCtrlFiltration<UserFilters>,
>(
  store: TStore,
): ColumnFiltersDict => ({
  role: multiSelectColumnFilter({
    getValues: () => store.filters?.role,
    setValues: (values: string[] | undefined) =>
      store.changeSingleFilter("role", values),
    options: roleOptions,
  }),
  status: multiSelectColumnFilter({
    getValues: () => store.filters?.status,
    setValues: (values: string[] | undefined) =>
      store.changeSingleFilter("status", values),
    options: statusOptions,
  }),
});
